import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0522b130"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = {
  class: "modal-dialog modal-lg modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = ["id"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import $ from 'jquery';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccessIssueNotesDialog',
  props: {
    name: {},
    title: {},
    notes: {}
  },
  setup(__props: any, { expose: __expose }) {

const store = useStore();
const _accessissues = computed(() => store.getters['diary/accessissues']);
const setBookingDeep = async (payload: {
  path: string;
  data: any;
}) => {
  await store.dispatch('diary/setBookingDeep', payload);
}
const props = __props;

const accessissues = computed({
  get: () => _accessissues.value,
  set: (data: string) => {
    setBookingDeep({ path: 'accessissues', data });
  }
});

const show = () => {
  if ($(`#${props.name}-modal` + 'Backdrop').length == 0) {
    const backdropDiv = $(`<div class="modal-backdrop fade show" id="${props.name}-modalBackdrop"></div>`);
    $('body').append(backdropDiv);
    $(`#${props.name}-modal`).show();
  }
}
const hide = async (val: boolean) => {
  if ($(`#${props.name}-modal`).length > 0) {
    $(`#${props.name}-modal` + 'Backdrop').remove();
    $(`#${props.name}-modal`).hide();
  }
};

__expose({ show, hide });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    id: `${_ctx.name}-modal`,
    "aria-labelledby": `${_ctx.name}-modal-label`,
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", {
            class: "modal-title",
            id: `${_ctx.name}-modal-label`
          }, _toDisplayString(_ctx.title), 9, _hoisted_5),
          _createElementVNode("button", {
            id: "close",
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide(false)), ["prevent"]))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              rows: "20",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((accessissues).value = $event))
            }, null, 512), [
              [
                _vModelText,
                accessissues.value,
                void 0,
                { lazy: true }
              ]
            ])
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})